<script lang="ts">
  import axios from 'axios'
  import moment from 'moment'
  import { onMount, onDestroy } from 'svelte'

  let {
    message = {}
  } = $props()

  let tick = $state(0)
  let intervalId: ReturnType<typeof setInterval>

  onMount(() => {
    intervalId = setInterval(() => tick++, 30000)
  })

  onDestroy(() => {
    if (intervalId) clearInterval(intervalId)
  })

  function timeAgo(dateString: string | null): string {
    tick // reference tick to trigger reactivity
    if (!dateString) return '—'
    return moment(dateString).fromNow()
  }

  let is_pending = $derived(!message.sent_at)
  let li_class = $derived(`live-stream-message msg-${message.direction} ${is_pending ? "msg-pending" : ""}`)
  let url = $derived(`/superadmin/users/${message.account?.owner_id}/impersonate_start`)

  function onclick(e) {
    e.preventDefault()
    axios.post(url)
  }
</script>

<li class={li_class}>
  <div class="live-stream-message__text">
    {#if message.direction === 'ai_response'}<span class="msg-badge msg-badge--ai">AI</span>{/if}
    {message.text_for_display}
  </div>
  <div class="live-stream-message__info">
    <a href={url} {onclick}>Account: {message.account_id}, </a>
  </div>
  <div class="live-stream-message__info live-stream-message__send-at">Send at:
    <span class="timeago" title={message.send_at}>{timeAgo(message.send_at)}</span>,
  </div>
  <div class="live-stream-message__info">Sent at:
    <span class="timeago" title={message.sent_at}>{timeAgo(message.sent_at)}</span>,
  </div>
  <div class="live-stream-message__info live-stream-message__credits">Credit cost: {message.credits}</div>
</li>

<style>
  .msg-badge {
    display: inline-block;
    font-size: 0.7em;
    font-weight: 600;
    letter-spacing: 0.05em;
    padding: 0.1em 0.45em;
    margin-right: 0.4em;
    border-radius: 0.25em;
    vertical-align: middle;
  }

  .msg-badge--ai {
    background: rgb(237, 233, 254);
    color: rgb(91, 33, 182);
  }
</style>
